import React, { createContext, useContext, useState, ReactNode } from 'react';

interface PageHeaderData {
  title: string;
  description?: string;
  icon?: React.ComponentType<{ className?: string }>;
  stats?: Array<{
    label: string;
    value: string | number;
    color?: string;
    dotColor?: string;
  }>;
}

interface PageHeaderContextType {
  headerData: PageHeaderData | null;
  setHeaderData: (data: PageHeaderData | null) => void;
}

const PageHeaderContext = createContext<PageHeaderContextType | undefined>(undefined);

export const usePageHeader = () => {
  const context = useContext(PageHeaderContext);
  if (!context) {
    throw new Error('usePageHeader must be used within a PageHeaderProvider');
  }
  return context;
};

interface PageHeaderProviderProps {
  children: ReactNode;
}

export const PageHeaderProvider: React.FC<PageHeaderProviderProps> = ({ children }) => {
  const [headerData, setHeaderData] = useState<PageHeaderData | null>(null);

  return (
    <PageHeaderContext.Provider value={{ headerData, setHeaderData }}>
      {children}
    </PageHeaderContext.Provider>
  );
};